/**
 * Разбор имени файла для отображения как в web-client (FileCards).
 */
export function getFileInfo(filename: string): { name: string; extension: string } {
  const [, name, extension] = filename.match(/^(.+)\.(\w+)$/) ?? ['', filename, ''];
  return { name, extension };
}

/**
 * Формат размера файла как в основной системе (Кб / Мб).
 */
export function formatFileSize(size: number): string {
  const kb = Math.ceil(size / 1024);
  const mb = Number((kb / 1024).toFixed().replace(/\.0+$/g, ''));
  return mb > 0 ? `${mb} Мб` : `${kb} Кб`;
}
